import { mapGetters } from 'vuex'

export default {
    methods: {
        convertTimeToMinutesAndHours (time) {
            let hrs = Math.floor(time / 3600)
            let mins = Math.floor((time % 3600) / 60)
            let secs = Math.floor(time % 60)

            let formattedTime = ''
            if (hrs > 0) {
                formattedTime += hrs + ':'
            }
            if (mins < 10) {
                formattedTime += '0' + mins + ':' + (secs < 10 ? '0' : '')
            } else {
                formattedTime += '' + mins + ':' + (secs < 10 ? '0' : '')
            }
            formattedTime += '' + secs
            return formattedTime
        },
        convertTimeToMinutesAndHoursForElement (element) {
            let totalTime = null
            element.sections.forEach(elementSection => {
                if (elementSection.type === 'video') {
                    totalTime += elementSection.duration
                }
            })
            if (totalTime === null) {
                return ''
            }
            let hrs = Math.floor(totalTime / 3600)
            let mins = Math.floor((totalTime % 3600) / 60)
            let secs = Math.floor(totalTime % 60)

            let formattedTotalTime = ''
            if (hrs > 0) {
                formattedTotalTime += '' + hrs + ':'
            }
            if (mins < 10) {
                formattedTotalTime += '0' + mins + ':' + (secs < 10 ? '0' : '')
            } else {
                formattedTotalTime += '' + mins + ':' + (secs < 10 ? '0' : '')
            }
            formattedTotalTime += '' + secs
            return formattedTotalTime
        },
        getElementQueryParameterByName (name, url = window.location.href) {
            name = name.replace(/[\[\]]/g, '\\$&')
            var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
            var results = regex.exec(url)
            if (!results) return null
            if (!results[2]) return ''
            return decodeURIComponent(results[2].replace(/\+/g, ' '))
        },
        getFirstMicroLearningSectionWithVideo () {
            const microLearningElementWithVideo = this.groupedMicroLearningElements.find(microLearningElement => {
                return microLearningElement.sections.find(section => section.type === 'video')
            })
            return microLearningElementWithVideo.sections[0]
        },
        getMicroLearningSectionWithElementId (elementId) {
            const section = this.microLearningSections.find(microLearningSection => microLearningSection.elementId === elementId)
            if (!section) {
                return null
            }
            return section
        },
        async assignMicroLearningSectionAndChangeVideo (microLearningSection) {
            await this.$store.dispatch('MicroLearning/assignMicroLearningSection', microLearningSection)
            await this.$store.dispatch('Courses/changeCourseVideo', microLearningSection)
        },
        async setMicroLearningSectionsAndVideoLogs () {
            if (this.isLoggedIn) {
                const videoLogs = await this.$store.dispatch('VideoLog/loadVideoLogForMicroLearningElements', {
                    courseId: this.course.id
                })
                await this.$store.dispatch('MicroLearning/setMicroLearningVideoLogs', videoLogs)
            }
            await this.$store.dispatch('MicroLearning/assignMicroLearningSections', this.course.elements)
            if (this.getElementQueryParameterByName('element')) {
                let elementId = +this.getElementQueryParameterByName('element')
                if (this.getMicroLearningSectionWithElementId(elementId) === null) {
                    this.$router.replace({ name: this.getCorrectRouteForMicroLearning, query: { element: this.getFirstMicroLearningSectionWithVideo().elementId } })
                    await this.assignMicroLearningSectionAndChangeVideo(this.getFirstMicroLearningSectionWithVideo())
                } else {
                    await this.assignMicroLearningSectionAndChangeVideo(this.getMicroLearningSectionWithElementId(elementId))
                }
            } else {
                if (this.lastWatchedSectionInfo) {
                    if (this.getMicroLearningSectionWithElementId(this.lastWatchedSectionInfo.elementId) === null) {
                        this.$router.replace({ name: this.getCorrectRouteForMicroLearning, query: { element: this.getFirstMicroLearningSectionWithVideo().elementId } })
                        await this.assignMicroLearningSectionAndChangeVideo(this.getFirstMicroLearningSectionWithVideo())
                    } else {
                        this.$router.replace({ name: this.getCorrectRouteForMicroLearning, query: { element: this.lastWatchedSectionInfo.elementId } })
                        await this.assignMicroLearningSectionAndChangeVideo(this.getMicroLearningSectionWithElementId(this.lastWatchedSectionInfo.elementId))
                    }
                } else {
                    await this.assignMicroLearningSectionAndChangeVideo(this.getFirstMicroLearningSectionWithVideo())
                    this.$router.replace({ name: this.getCorrectRouteForMicroLearning, query: { element: this.getFirstMicroLearningSectionWithVideo().elementId } })
                }
            }
        },
        async selectMicroLearningSection (value) {
            const scrollPosition = document.documentElement.scrollTop
            clearInterval(this.nextVideoInterval)
            const nextSectionIndex = (this.getCurrentSectionIndex() + value)
            const nextSection = this.microLearningSections[nextSectionIndex]
            await this.$store.dispatch('MicroLearning/assignMicroLearningSection', nextSection)
            this.$router.replace({ name: this.getCorrectRouteForMicroLearning, query: { element: nextSection.elementId } })
            if (nextSection.type === 'video') {
                await this.$store.dispatch('Courses/changeCourseVideo', nextSection)
                this.$emit('reInitializeVideo')
            }
            document.documentElement.scrollTop = scrollPosition
        },
        getCurrentSectionIndex () {
            if (!this.microLearningSection || !this.microLearningSections) {
                return null
            }
            return this.microLearningSections.map(element => element.elementId).indexOf(this.microLearningSection.elementId)
        }
    },
    computed: {
        ...mapGetters({
            microLearningSection: 'MicroLearning/getMicroLearningSection',
            microLearningSections: 'MicroLearning/getMicroLearningSections',
            isMicroLearningCourse: 'MicroLearning/isMicroLearningCourse'
        }),
        groupedMicroLearningElements () {
            let microLearningElements = []
            let ids = []
            let microLearningElement = {
                title: '',
                sections: []
            }
            this.course.elements.forEach(element => {
                if (element.type === 'section') {
                    if (ids.length === 0) {
                        ids.push(element.elementId)
                        microLearningElement.title = element.title
                    }
                } else {
                    microLearningElement.sections.push(element)
                }
                if (element.type === 'section' && !ids.includes(element.elementId)) {
                    microLearningElement = {
                        title: element.title,
                        sections: []
                    }
                    ids.push(element.elementId)
                }
                if (ids.includes(element.elementId) && element.type === 'section') {
                    microLearningElements.push(microLearningElement)
                }
            })
            return microLearningElements
        },
        getMicroLearningSectionType () {
            if (this.currentMicroLearningSection === null || this.currentMicroLearningSection === undefined) {
                return null
            }
            return this.currentMicroLearningSection.type
        },
        getCorrectRouteForMicroLearning () {
            return this.$router.currentRoute.name
        },
        isFirstSection () {
            if (this.isCollectionCoursePage) {
                return this.isFirstCollectionSection && this.isFirstMicroLearningSection
            }
            return this.getCurrentSectionIndex() === 0 || this.getCurrentSectionIndex() < 0
        },
        isLastSection () {
            if (this.isCollectionCoursePage) {
                return this.isLastCollectionSection && this.isLastMicroLearningSection
            }
            return this.isLastMicroLearningSection
        },
        isFirstMicroLearningSection () {
            return this.getCurrentSectionIndex() === 0 || this.getCurrentSectionIndex() < 0
        },
        isLastMicroLearningSection () {
            if(!this.microLearningSections) {
                return false
            }
            return this.getCurrentSectionIndex() === (this.microLearningSections.length - 1) || this.getCurrentSectionIndex() > (this.microLearningSections.length - 1)
        },
        isFirstCollectionSection () {
            return this.coursePositionInArray === 0
        },
        isLastCollectionSection () {
            return this.coursePositionInArray === this.collectionAllCourses.length - 1
        },
        coursePositionInArray () {
            return this.collectionAllCourses.indexOf(this.currentCourse)
        },
        currentCourse () {
            return this.collectionAllCourses.find(el => el.id === this.currentCourseId)
        }
    }
}
